<template>
  <v-container>
    <div class="mt-10">
      <div>
        <h3 class="primary--text">Announcements</h3>
      </div>
      <div class="d-flex">
        <div class="mr-5" style="width: 70%;">
          <announcement-card
            v-for="(announcement, key) in announcements.slice(0, 3)"
            :key="key"
            :title="announcement.title"
            :content="announcement.content"
            :image="announcement.image"
          ></announcement-card>
          <v-btn
            outlined
            block
            class="text-none primary--text"
          >
            More
          </v-btn>
        </div>

        <div style="width: 30%;">
          <v-card
            color="secondary"
            rounded="0"
            outlined
            class="pa-5"
            height="100%"
          >
            <h3 class="grey--text text--darken-2">Links</h3>
            <v-list color="transparent">
              <v-list-item
                v-for="(link, key) in links"
                :key="key"
                class="px-0 clickable"
              >
                <v-icon size="50" color="#70F1CA">mdi-chevron-right</v-icon>
                <span class="primary--text">{{ link.name }}</span>
              </v-list-item>
            </v-list>
          </v-card>
        </div>
      </div>
    </div>

    <v-row class="mt-10">
      <v-col cols="12">
        <h3 class="primary--text">Other</h3>
      </v-col>
      <v-col cols="12">
        <slider-card :details="announcements"></slider-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',
    
    components: {
      AnnouncementCard: () => import('./components/AnnouncementCard.vue'),
      SliderCard: () => import('./components/SliderCard.vue'),
    },

    data: ()=>({
      announcements: [
        {
          title: 'Title',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec metus ipsum, iaculis volutpat sodales in, tempor non mauris. Donec lobortis vestibulum quam non luctus. Morbi ut turpis pulvinar, imperdiet odio et, placerat nibh. Quisque vulputate purus id mauris feugiat hendrerit. Donec iaculis euismod neque, sollicitudin malesuada urna rhoncus nec. Etiam ullamcorper, dolor a laoreet dignissim, velit nulla euismod lacus, eu dapibus sem nisi eget nunc. Donec gravida eu enim sed elementum. Maecenas commodo odio vel est malesuada ullamcorper. Ut velit eros, semper at accumsan sed, euismod sit amet lacus. Sed feugiat accumsan enim vitae pulvinar.',
          image: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg'
        },
        {
          title: 'Title',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec metus ipsum, iaculis volutpat sodales in, tempor non mauris. Donec lobortis vestibulum quam non luctus. Morbi ut turpis pulvinar, imperdiet odio et, placerat nibh. Quisque vulputate purus id mauris feugiat hendrerit. Donec iaculis euismod neque, sollicitudin malesuada urna rhoncus nec. Etiam ullamcorper, dolor a laoreet dignissim, velit nulla euismod lacus, eu dapibus sem nisi eget nunc. Donec gravida eu enim sed elementum. Maecenas commodo odio vel est malesuada ullamcorper. Ut velit eros, semper at accumsan sed, euismod sit amet lacus. Sed feugiat accumsan enim vitae pulvinar.',
          image: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg'
        },
        {
          title: 'Title',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec metus ipsum, iaculis volutpat sodales in, tempor non mauris. Donec lobortis vestibulum quam non luctus. Morbi ut turpis pulvinar, imperdiet odio et, placerat nibh. Quisque vulputate purus id mauris feugiat hendrerit. Donec iaculis euismod neque, sollicitudin malesuada.',
          image: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg'
        },
        {
          title: 'Title',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec metus ipsum, iaculis volutpat sodales in, tempor non mauris. Donec lobortis vestibulum quam non luctus. Morbi ut turpis pulvinar, imperdiet odio et, placerat nibh. Quisque vulputate purus id mauris feugiat hendrerit. Donec iaculis euismod neque, sollicitudin malesuada urna rhoncus nec. Etiam ullamcorper, dolor a laoreet dignissim, velit nulla euismod lacus, eu dapibus sem nisi eget nunc. Donec gravida eu enim sed elementum. Maecenas commodo odio vel est malesuada ullamcorper. Ut velit eros, semper at accumsan sed, euismod sit amet lacus. Sed feugiat accumsan enim vitae pulvinar.',
          image: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg'
        },
        {
          title: 'Title',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec metus ipsum, iaculis volutpat sodales in, tempor non mauris. Donec lobortis vestibulum quam non luctus. Morbi ut turpis pulvinar, imperdiet odio et, placerat nibh. Quisque vulputate purus id mauris feugiat hendrerit. Donec iaculis euismod neque, sollicitudin malesuada.',
          image: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg'
        },
        {
          title: 'Title',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec metus ipsum, iaculis volutpat sodales in, tempor non mauris. Donec lobortis vestibulum quam non luctus. Morbi ut turpis pulvinar, imperdiet odio et, placerat nibh. Quisque vulputate purus id mauris feugiat hendrerit. Donec iaculis euismod neque, sollicitudin malesuada urna rhoncus nec. Etiam ullamcorper, dolor a laoreet dignissim, velit nulla euismod lacus, eu dapibus sem nisi eget nunc. Donec gravida eu enim sed elementum. Maecenas commodo odio vel est malesuada ullamcorper. Ut velit eros, semper at accumsan sed, euismod sit amet lacus. Sed feugiat accumsan enim vitae pulvinar.',
          image: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg'
        }
      ],
      links: [
        {
          name: 'Service Desk',
          link: '/'
        },
        {
          name: 'Medgate Website',
          link: '/'
        },
        {
          name: 'MMS Site',
          link: '/'
        },
        {
          name: 'Link 4',
          link: '/'
        },
        {
          name: 'Link 5',
          link: '/'
        },
        {
          name: 'Link 6',
          link: '/'
        }
      ]
    }),

    methods: {
      //
    }
  }
</script>

<style lang="scss" scoped>

</style>